import { IndiaRupee } from "./AppConstants"

const ModalContent = {
    RemoveItemFromCart: {
        title: 'Do you really want to remove this item from your bag?',
        subTitle: 'Once removed, you\'ll only be able to go back and add items manually',
        primaryCTATitle: 'Yes', secondaryCTATitle: 'No'
    },
    RemoveImageFromCart: {
        title: 'Please Confirm',
        subTitle: 'Are you sure you want to remove this photo? The photo added will get deleted.',
        primaryCTATitle: 'Yes', secondaryCTATitle: 'No'
    },
    DeleteAddress: {
        title: 'Please Confirm',
        subTitle: 'Are you sure you want to delete this address?',
        primaryCTATitle: 'Yes', secondaryCTATitle: 'No'
    },
    Logout: {
        title: 'Are you sure you want to logout?',
        subTitle: '', primaryCTATitle: 'Yes', secondaryCTATitle: 'No'
    },
    Reorder: {
        title: 'Please Confirm',
        subTitle: 'Add item in cart, else clear cart',
        primaryCTATitle: 'Continue', secondaryCTATitle: 'Clear'
    },
    BlockedLocation: {
        title: 'Unable to fetch GPS location',
        subTitle: 'You\'ve blocked us from tracking your location. Please change your location settings in the browser.',
        ctaTitle: 'Select your location'
    },
    ZeroPharmacy: {
        title: 'Location is not serviceable',
        subTitle: 'Our services are not available at your location yet. Please switch the location to a serviceable area for better experience.',
        ctaTitle: 'Change location'
    },
    CancelOrder: {
        title: 'Please Confirm',
        subTitle: 'Are you sure you want to cancel this order? Once cancelled you will have to create a new order.',
        primaryCTATitle: 'Yes', secondaryCTATitle: 'No'
    },
    ServicePaymentSubscriptionBackpress: {
        title: 'This case will be saved. You can come back later to submit this case.',
        subTitle: '', primaryCTATitle: 'Yes', secondaryCTATitle: 'No'
    },
    QuestionaireBackpress: {
        title: 'You will lose your progress. Is that OK?',
        subTitle: '', primaryCTATitle: 'Yes', secondaryCTATitle: 'No'
    },
    ReviewQuestionAnswerBackpress: {
        title: 'You will lose your progress. Is that OK?',
        subTitle: '', primaryCTATitle: 'Yes', secondaryCTATitle: 'No'
    },
    MarkOrderDelivered: {
        title: 'Confirm Order Delivery',
        subTitle: 'Note: Earn a scratch card when you confirm the delivery of the order on Aayu app (Google Play Store)',
        primaryCTATitle: 'Yes, Delivered', secondaryCTATitle: 'No, Get Help',
    },
    CashOnDelivery: {
        title: 'Continue To Pay ' + IndiaRupee,
        subTitle: 'Sehat Sikke is not valid on cash on delivery.',
        primaryCTATitle: 'Pay Online', secondaryCTATitle: 'Continue',
    },
    EnablePushNotification: {
        title: 'Please Confirm',
        subTitle: 'You want to enable push notifications to apply this promo code.',
        ctaTitle: 'Continue'
    },
    UserProfileCreated: {
        title: 'Congratulation, ',
        subTitle: 'Your profile is succesfully created',
        ctaTitle: 'OK'
    }
}

export default ModalContent